export default [
    {
        id: 1,
        name: "SapphireTemplate",
        description: "SapphireDescription",
        img: "./img/Szafir.png",
        imgAlt: "Szafir",
        internal: false
    },
    {
        id: 2,
        name: "RubinTemplate",
        description: "RubinDescription",
        img: "./img/Rubin.png",
        imgAlt: "Rubin",
        internal: true
    }
]